var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: {
            name: "modalview",
            height: "auto",
            resizable: false,
            adaptive: false,
            scrollable: true
          }
        },
        [
          _c("div", { staticClass: "modal-header" }),
          _c(
            "div",
            {
              staticClass: "modal-body",
              staticStyle: { "text-align": "center" }
            },
            [
              _c("Preview", { ref: "Preview", attrs: { val: _vm.mydata } }),
              _c("br"),
              _c("button", { on: { click: _vm.closePreview } }, [
                _vm._v("入力画面に戻る")
              ])
            ],
            1
          )
        ]
      ),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 offset-md-3 mb-5" }, [
      _c(
        "div",
        { staticClass: "thanks-form", staticStyle: { "text-align": "center" } },
        [
          _c("h1", [_c("b", [_vm._v("エントリーありがとうございました。")])]),
          _c("p", { staticClass: "thanks-form-content" }, [
            _vm._v(" ご記入いただいた履歴書は無事送信されました。"),
            _c("br"),
            _vm._v(
              " 確認のためご記入者へ自動返信メールを送らせていただきました。"
            ),
            _c("br"),
            _vm._v(
              " メールが届かない場合は、お手数ですが再度お問合せいただくか、弊社までご一報ください。 "
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }